import React from "react";
import { Col, Row } from "react-bootstrap";
import Stat from "../Common/Stat";
import StatBar from "../Common/StatBar";
import "../QuestionReport.css";
import IsSmallScreen from "../Common/IsSmallScreen";
import { htmlDecode } from "../../../../utils/parse";

const AssertionReasoning = ({ q, studentId, index }) => {
  const optIds = ["op1", "op2", "op3", "op4"];

  const options = {
    op1: { total: 0, correct: false },
    op2: { total: 0, correct: false },
    op3: { total: 0, correct: false },
    op4: { total: 0, correct: false },
  };

  const markedOpt = {
    op1: { selected: false, correct: false },
    op2: { selected: false, correct: false },
    op3: { selected: false, correct: false },
    op4: { selected: false, correct: false },
  };

  // ✅ Overall stats
  optIds.forEach((op) => {
    let st = q.statistics.filter(
      (stats) => stats?.answer?.["assertion-reasoning"]?.optionId === op,
    );

    options[op].correct =
      q.questionId?.correctAnswers?.["assertion-reasoning"]?.option === op;

    options[op].total = st ? st.length : 0;
  });

  // ✅ Current user selection
  const user = q.statistics.find((s) => s.userId === studentId);

  if (user) {
    const selectedOp = user?.answer?.["assertion-reasoning"]?.optionId;

    optIds.forEach((op) => {
      markedOpt[op].selected = selectedOp === op;
      markedOpt[op].correct =
        q.questionId.correctAnswers?.["assertion-reasoning"]?.option === op;
    });
  }

  const isSmallScreen = IsSmallScreen;

  // ✅ Explanation (text OR file)
  const userExplanation = user?.answer?.["assertion-reasoning"]?.answer;
  const userFile = user?.answer?.["assertion-reasoning"]?.file;
  const status = user?.status;

  return (
    <Row className="analytics_question_layer">
      <Col className="analytics_question_content">
        {/* Header */}
        <Row className="analytics_question_heading">
          <p>Question {index}</p>
          {q.questionId?.difficulty ? (
            <p className="analytics_question_heading_card">
              {q.questionId.difficulty}
            </p>
          ) : null}
          {q.questionId.cognitive ? (
            <p className="analytics_question_heading_card">
              {q.questionId.cognitive}
            </p>
          ) : null}
        </Row>

        {/* Assertion */}
        <Row className="analytics_question_statement">
          <strong>Assertion (A): </strong>
          <span
            dangerouslySetInnerHTML={{
              __html: htmlDecode(q.questionId.description.assertion),
            }}
          />
        </Row>

        {/* Reason */}
        <Row className="analytics_question_statement">
          <strong>Reason (R): </strong>
          <span
            dangerouslySetInnerHTML={{
              __html: htmlDecode(q.questionId.description.reasoning),
            }}
          />
        </Row>

        {/* Options */}
        <Row>
          {q.questionId.options.map((opt, ind) => {
            const state = markedOpt[opt.optionId];

            return (
              <Row
                key={opt.optionId}
                className="analytics_question_option"
                style={{
                  background: state.selected
                    ? state.correct
                      ? "linear-gradient(90deg, #7EB6A2 32.75%, #FFFFFF 96.35%)"
                      : "linear-gradient(90deg, #FF675E 32.75%, #FFFFFF 96.35%)"
                    : "linear-gradient(90deg, #ddd 32.75%, #FFFFFF 96.35%)",
                }}
              >
                <Col className="option_label">
                  {String.fromCharCode(65 + ind)}
                </Col>
                <Col
                  className="option_content"
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(opt.value),
                  }}
                />
              </Row>
            );
          })}
        </Row>

        <br />
        {/* ✅ Explanation Section */}
        {(userExplanation || userFile) && (
          <Row className="analytics_question_statement">
            <label>Student Explanation:</label>

            <div
              style={{ color: status === "correct" ? "#7EB6A2" : "#FF675E" }}
            >
              {userExplanation && (
                <p
                  style={{ fontWeight: 500 }}
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(userExplanation),
                  }}
                />
              )}

              {userFile && (
                <a
                  style={{
                    color: status === "correct" ? "#7EB6A2" : "#FF675E",
                  }}
                  href={userFile.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  📄 View File: {userFile.name}
                </a>
              )}
            </div>
          </Row>
        )}

        {/* ✅ Correct Explanation */}
        {q.questionId.correctAnswers?.["assertion-reasoning"]?.explanation && (
          <Row className="analytics_question_statement">
            <label>Correct Answer:</label>
            <p>
              <b>
                {q.questionId.correctAnswers["assertion-reasoning"].explanation}
              </b>
            </p>
          </Row>
        )}
      </Col>

      {/* Stats */}
      <Col className="analytics_question_stats">
        {optIds.map((op, i) => {
          return (
            <Stat key={op}>
              {String.fromCharCode(65 + i)}
              <StatBar
                style={{
                  width: (options[op].total / q.statistics.length) * 80 || 0,
                  height: isSmallScreen ? 15 : 30,
                  backgroundColor: options[op].correct ? "#7EB6A2" : "",
                }}
              />{" "}
              {options[op].total} Students
            </Stat>
          );
        })}
      </Col>
    </Row>
  );
};

export default AssertionReasoning;
